"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
//.input-error class is what we will toggle
var AddFirstAndLastName = /*#__PURE__*/function (_React$Component) {
  _inherits(AddFirstAndLastName, _React$Component);
  function AddFirstAndLastName(props) {
    var _this;
    _classCallCheck(this, AddFirstAndLastName);
    _this = _callSuper(this, AddFirstAndLastName, [props]);
    _this.state = {
      firstName: "",
      lastName: "",
      firstNameHasError: false,
      lastNameHasError: false,
      firstNameErrorMessage: "",
      lastNameErrorMessage: ""
    };
    _this.checkAndSave = _this.checkAndSave.bind(_assertThisInitialized(_this));
    _this.setName = _this.setName.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(AddFirstAndLastName, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      //set name from props to state so input => onChange, we can capture
      var user = this.props.user,
        firstName = user.first_name || "",
        lastName = user.last_name || "";
      this.setState({
        firstName: firstName,
        lastName: lastName
      });
    }
  }, {
    key: "checkAndSave",
    value: function checkAndSave(event) {
      event.preventDefault();
      var newState = {},
        hasError = false;
      if (2 > this.state.firstName.length) {
        newState.firstNameHasError = true;
        newState.firstNameErrorMessage = this.props.intl.formatMessage({
          id: 'shared_components.add_first_and_last_name.first_use_more_chars',
          defaultMessage: 'Please use at least two or more characters'
        });
        hasError = true;
      }
      if (2 > this.state.lastName.length) {
        newState.lastNameHasError = true;
        newState.lastNameErrorMessage = this.props.intl.formatMessage({
          id: 'shared_components.add_first_and_last_name.last_use_more_chars',
          defaultMessage: 'Please use at least two or more characters'
        });
        hasError = true;
      }
      if (hasError) {
        this.setState(newState);
      } else {
        var data = {};
        data.first_name = this.state.firstName;
        data.last_name = this.state.lastName;
        this.props.updateAction(this.props.user.SSOid, JSON.stringify(data), this.props.callback);
      }
    }
  }, {
    key: "setName",
    value: function setName(event) {
      var input = event.target;
      var value = input.value;
      var fieldID = input.getAttribute('id');
      var newState = {};
      if (value) {
        var currentHasErrorKey = "".concat(fieldID, "HasError");
        var currentErrorMessageKey = "".concat(fieldID, "ErrorMessage");
        newState[currentHasErrorKey] = false;
        newState[currentErrorMessageKey] = '';
      }
      newState[fieldID] = value;
      this.setState(newState);
    }
  }, {
    key: "render",
    value: function render() {
      var firstName = this.state.firstName;
      var lastName = this.state.lastName;
      var lastNameInputClass = "col-xs-12",
        firstNameInputClass = "col-xs-12",
        lastNameErrMsg = "",
        firstNameErrMsg = "";
      if (this.state.firstNameHasError) {
        firstNameInputClass = firstNameInputClass + " input-error";
        firstNameErrMsg = "text-danger";
      }
      if (this.state.lastNameHasError) {
        lastNameInputClass = lastNameInputClass + " input-error";
        lastNameErrMsg = "text-danger";
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "add-name"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "text-center"
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.add_first_and_last_name.add_name",
        defaultMessage: "Add Your Name"
      })), /*#__PURE__*/_react.default.createElement("form", {
        id: "add-name-form",
        className: "col-xs-6 col-xs-offset-3"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12",
        id: "first-name-area"
      }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.add_first_and_last_name.first_name",
        defaultMessage: "First Name"
      })), /*#__PURE__*/_react.default.createElement("input", {
        id: "firstName",
        className: firstNameInputClass,
        value: firstName,
        placeholder: this.props.intl.formatMessage({
          id: 'shared_components.add_first_and_last_name.input_first_name_placeholder',
          defaultMessage: 'John'
        }),
        onChange: this.setName
      }), /*#__PURE__*/_react.default.createElement("p", {
        className: firstNameErrMsg
      }, this.state.firstNameErrorMessage)), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12",
        id: "last-name-area"
      }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.add_first_and_last_name.last_name",
        defaultMessage: "Last Name"
      })), /*#__PURE__*/_react.default.createElement("input", {
        id: "lastName",
        className: lastNameInputClass,
        value: lastName,
        placeholder: this.props.intl.formatMessage({
          id: 'shared_components.add_first_and_last_name.input_last_name_placeholder',
          defaultMessage: 'Doe'
        }),
        onChange: this.setName
      }), /*#__PURE__*/_react.default.createElement("p", {
        className: lastNameErrMsg
      }, this.state.lastNameErrorMessage)), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/_react.default.createElement("button", {
        id: "save-name-btn",
        className: "col-xs-12 btn btn-lg btn-primary",
        onClick: this.checkAndSave
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "shared_components.add_first_and_last_name.button_save",
        defaultMessage: "Save"
      })))));
    }
  }]);
  return AddFirstAndLastName;
}(_react.default.Component);
var _default = exports.default = (0, _reactIntl.injectIntl)(AddFirstAndLastName);